/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleClaimCenterBookableRequest
 */
export interface ScheduleClaimCenterBookableRequest {
    /**
     * ISO8601 local date string , e.g. 2025-04-16
     * @type {string}
     * @memberof ScheduleClaimCenterBookableRequest
     */
    localDate: string;
}

/**
 * Check if a given object implements the ScheduleClaimCenterBookableRequest interface.
 */
export function instanceOfScheduleClaimCenterBookableRequest(value: object): value is ScheduleClaimCenterBookableRequest {
    if (!('localDate' in value) || value['localDate'] === undefined) return false;
    return true;
}

export function ScheduleClaimCenterBookableRequestFromJSON(json: any): ScheduleClaimCenterBookableRequest {
    return ScheduleClaimCenterBookableRequestFromJSONTyped(json, false);
}

export function ScheduleClaimCenterBookableRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleClaimCenterBookableRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'localDate': json['localDate'],
    };
}

export function ScheduleClaimCenterBookableRequestToJSON(value?: ScheduleClaimCenterBookableRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'localDate': value['localDate'],
    };
}

